import React from 'react'
import { SvgIcon } from '@material-ui/core'

const SearchIcon = (props) => {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="19.5" height="19.5" viewBox="0 0 19.5 19.5">
      <path data-name="Path 12458" d="m1134.53 53.47-3.507-3.508a7.432 7.432 0 0 0 1.5-3.01 12.679 12.679 0 0 0 0-5.8 7.469 7.469 0 0 0-5.567-5.567 12.679 12.679 0 0 0-5.8 0 7.47 7.47 0 0 0-5.568 5.567 12.706 12.706 0 0 0 0 5.8 7.471 7.471 0 0 0 5.568 5.568 12.707 12.707 0 0 0 5.8 0 7.447 7.447 0 0 0 3.01-1.5l3.508 3.507a.75.75 0 0 0 1.06-1.06zm-7.92-2.411a11.187 11.187 0 0 1-5.115 0 5.969 5.969 0 0 1-4.449-4.449 11.187 11.187 0 0 1 0-5.115 5.971 5.971 0 0 1 4.449-4.449 11.187 11.187 0 0 1 5.115 0 5.972 5.972 0 0 1 4.449 4.449 11.187 11.187 0 0 1 0 5.115 5.971 5.971 0 0 1-4.449 4.449z" transform="translate(-1115.25 -35.25)" fill="#acacac" />
    </SvgIcon>
  )
}

export default SearchIcon
